export { default as DefaultPage } from './DefaultPage';
export { default as MasterPage } from './MasterPage';
export { default as PaginaNaoEncontrada } from './PaginaNaoEncontrada';



// WEBPACK FOOTER //
// ./src/features/master-page/index.js